export default __webpack_public_path__ + "static/media/Icon_1.23123c91.png";